module.exports = __webpack_public_path__ + "static/media/slide2.b5cd28e0.jpeg";